import { useMemo } from 'react'

import { useTranslate } from '@/src/lang/useTranslate'

import type { TIntention } from '../../models/Intention.types'

export const usePrettifyPrayers = (prayers?: TIntention['prayers']): { all: string; first: string; others: string } => {
  const { t } = useTranslate()
  const anonymous = t('intention.anonymous-praying')

  const cleanPrayers = useMemo(
    () =>
      prayers
        ?.map((prayer) => prayer.userName || anonymous)
        // Sort anonymous at the end to avoid displaying "Anonymous and 2 other people" for example
        .sort((a, b) => {
          let result
          if (a === anonymous) {
            result = 1
          } else if (b === anonymous) {
            result = -1
          } else {
            result = 0
          }
          return result
        }) ?? [],
    [anonymous, prayers],
  )

  if (!prayers || prayers.length === 0) {
    return { first: '', others: '', all: '' }
  }

  const firstAmongOthers = `${cleanPrayers[0]}${cleanPrayers.length > 1 ? ', ' : ''}`
  const others = cleanPrayers.slice(1, 3).join(', ')

  return { first: cleanPrayers[0], others, all: `${firstAmongOthers}${others}` }
}
